import { useEffect, useState } from 'react';

interface TimerOtpProps {
  onResend: () => void;
  time: number;
}

function useCountdown({ onResend, time = 60 }: TimerOtpProps) {
  const [seconds, setSeconds] = useState(time);

  const startTimer = () => {
    setSeconds(time);
  };

  const formatNumber = (number: number) =>
    number.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });

  const onEnd = async () => {
    await onResend();
    startTimer();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
        return;
      }

      clearInterval(interval);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const formatterSeconds = formatNumber(seconds % 60);
  const formattedMinutes = formatNumber(Math.floor(seconds / 60));
  const isFinished = seconds === 0;

  return {
    minutes: formattedMinutes,
    seconds: formatterSeconds,
    isFinished,
    onEnd,
  };
}

export default useCountdown;
